import React, { memo } from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Check from '@mui/icons-material/Check';
import { alpha } from '@mui/material/styles';
import { JOB_KINDS, JobKind } from './jobModel';
import { JOB_KIND_META } from './jobKindMeta';

interface JobKindFilterProps {
  selected: ReadonlySet<JobKind>;
  counts: Record<JobKind, number>;
  onToggle: (kind: JobKind) => void;
}

/** Multi-select job type filter; nothing selected means all types. */
const JobKindFilter: React.FC<JobKindFilterProps> = ({ selected, counts, onToggle }) => (
  <Box role="group" aria-label="Filter jobs by type" sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
    {JOB_KINDS.map((kind) => {
      const { label, Icon } = JOB_KIND_META[kind];
      const on = selected.has(kind);
      return (
        <Chip
          key={kind}
          clickable
          aria-pressed={on}
          onClick={() => onToggle(kind)}
          icon={on ? <Check /> : <Icon />}
          label={
            <>
              {label}
              <Box component="span" sx={{ ml: 0.75, fontSize: 12, color: 'text.secondary' }}>
                {counts[kind]}
              </Box>
            </>
          }
          variant={on ? 'filled' : 'outlined'}
          sx={{
            height: 32,
            borderRadius: 2,
            fontSize: 13,
            fontWeight: 500,
            '& .MuiChip-icon': { fontSize: 16, ml: 1 },
            ...(on && {
              color: 'primary.dark',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              '& .MuiChip-icon': { fontSize: 16, ml: 1, color: 'primary.dark' },
            }),
          }}
        />
      );
    })}
  </Box>
);

export default memo(JobKindFilter);
